import typography from 'shared-tokens/utils/tokens/typography';

const width = 50;
const height = 30;
const padding = 3;
const inactiveBackground = '#e5e5e5';
const activeBackground = '#4cd964';
const pegInactiveBackground = 'white';
const pegActiveBackground = 'white';

export const mainCls = 'switch-control';

export default {
  [`${mainCls}`]: {
    '&': {
      display: 'flex',
      cursor: 'pointer',
      justifyContent: 'space-between',
      margin: '1em 0 1.4em 0',
      height: '18px',
      fontFamily: typography.tpFonts.l,
      fontSize: typography.tpSizes.m,
      lineHeight: '32px',
      '-webkit-tap-highlight-color': 'transparent',
      '&:focus': {
        outline: 0,
      },
    },
  },
  [`${mainCls}__input`]: {
    display: 'none',
    [`&:checked + .${mainCls}__track`]: {
      background: activeBackground,
      [`& > .${mainCls}__peg`]: {
        transform: `translate3d(${width - height}px, 0, 0)`,
        background: pegActiveBackground,
        boxShadow: `0 8px 8px rgba(29, 137, 47, 0.6)`,
      },
    },
  },

  [`${mainCls}__track`]: {
    display: 'block',
    width: `${width}px`,
    minWidth: `${width}px`,
    height: `${height}px`,
    background: inactiveBackground,
    borderRadius: `${height / 2}px`,
    position: 'relative',
    boxShadow: '0 0 0 0 transparent',
    transition: 'transform 300ms ease-out',
  },
  [`${mainCls}__peg`]: {
    display: 'block',
    position: 'absolute',
    top: padding,
    left: padding,
    width: `${height - padding * 2}px`,
    height: `${height - padding * 2}px`,
    background: pegInactiveBackground,
    borderRadius: '50%',
    boxShadow: '0 8px 8px rgba(165, 165, 165, 0.6)',
    transition: 'transform 300ms ease-out',
  },
};
